import { pick } from 'lodash-es';
/**
 * Radix UI passes some props to underlying host nodes via React.cloneElement for
 * popover primitives. Since Aether components don't pass the full ref to underlying
 * host node (as that pierces the React abstraction), we need to manually pick
 * the props that Radix UI passes.
 */
export function useRadixProps(props) {
    return pick(props, [
        'aria-checked',
        'aria-controls',
        'aria-describedby',
        'aria-disabled',
        'aria-expanded',
        'aria-haspopup',
        'data-disabled',
        'data-highlighted',
        'data-orientation',
        'data-radix-collection-item',
        'data-state',
        'onBlur',
        'onBlurCapture',
        'onClick',
        'onFocus',
        'onFocusCapture',
        'onKeyDown',
        'onMouseDown',
        'onPointerDown',
        'onPointerDownCapture',
        'onPointerEnter',
        'onPointerLeave',
        'onPointerMove',
        'onPointerUp',
        'onPointerUpCapture',
        'onTouchStart',
        'tabIndex',
    ]);
}
//# sourceMappingURL=useRadixProps.js.map